/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Score_StructureInputs */

const en_score_structure = /** @type {(inputs: Score_StructureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layout / Format`)
};

const de_score_structure = /** @type {(inputs: Score_StructureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layout / Format`)
};

/**
* | output |
* | --- |
* | "Layout / Format" |
*
* @param {Score_StructureInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const score_structure = /** @type {((inputs?: Score_StructureInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Score_StructureInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_score_structure(inputs)
	return en_score_structure(inputs)
});